"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCheckCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    fill: "inherit",
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M12 0C5.372 0 0 5.373 0 12c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12 0-6.626-5.374-12-12-12zm0 1.532c5.78 0 10.468 4.688 10.468 10.468 0 5.782-4.687 10.468-10.468 10.468-5.782 0-10.468-4.686-10.468-10.468C1.532 6.22 6.218 1.532 12 1.532z"
  }), React.createElement("path", {
    d: "M15.672 8.272a.75.75 0 011.22.866l-.064.09-4.971 6a.75.75 0 01-1.024.125l-.082-.07-3.029-3a.75.75 0 01.971-1.138l.085.072 2.446 2.423 4.448-5.368z"
  })));
}

var _default = SvgCheckCircle;
exports.default = _default;